import DateManager from "general_utils/datemanager";

export const getWaterYearStartAndEndFromGeoJson = (catchmentGeoJson) => {
    let latitude = getLatitudeFromCoordinates(getCoordinatesFromGeoJSON(catchmentGeoJson[0]));
    let water_year_start_month_and_day, water_year_end_month_and_day;
    if (isNorthHemisphere(latitude)) {
        water_year_start_month_and_day = "10-01";
        water_year_end_month_and_day = "09-30";
    } else {
        water_year_start_month_and_day = "07-01";
        water_year_end_month_and_day = "06-30";
    }
    return [water_year_start_month_and_day, water_year_end_month_and_day];
};
function getLatitudeFromCoordinates(coordinates) {
    return coordinates[1];
}

function isNorthHemisphere(lat) {
    return lat >= 0;
}

function getCoordinatesFromGeoJSON(geojson) {
    if (geojson.geometry.type === 'Polygon') {
      return geojson.geometry.coordinates[0][0];
    } else if (geojson.geometry.type === 'MultiPolygon') {
      return geojson.geometry.coordinates[0][0][0];
    } else return [];
}

export const fuseDatesAndValuesInSingleYear = (dates, values, years_arr, water_period_start, maxYearToFuseData = 2004) => {
    const datemanager = new DateManager();
    let [arr_dates, arr_values] = [[],[]];
    const minYearToFuseData = maxYearToFuseData - 1;
    for (let year of years_arr) {
        let [yearly_dates, yearly_values] = [[],[]];
        const start_date = new Date(year - 1 + "-" + water_period_start);
        const end_date = new Date(year + "-" + water_period_start);
        dates?.forEach((day, index)=> {
        let currentUTCDay = new Date(day);
        let dayInDatetimeFormat = datemanager.dateUTCAdjustment(currentUTCDay)
            if (DateManager.isDateAmongDates(dayInDatetimeFormat, start_date, end_date)) {
                if (dayInDatetimeFormat.getFullYear() === year) {
                    yearly_dates.push(DateManager.replaceYearFromStrDate(day, String(maxYearToFuseData)))
                } else {
                    yearly_dates.push(DateManager.replaceYearFromStrDate(day, String(minYearToFuseData)));
                }
                yearly_values.push(values[index]);
            }
        })
        if (yearly_dates?.length > 0 && yearly_values?.length > 0){
            arr_dates.push(yearly_dates);
            arr_values.push(yearly_values);
        }
    }
    return [arr_dates, arr_values];
  }

export const getUniqueSortedYearsFromDate = (datesArray, compareDate="10-01") => {
    const [compareMonth, compareDay] = compareDate.split("-").map(Number);
    const years = datesArray.map(date => {
        const [year, month, day] = date.split("-").map(Number);
        return (month > compareMonth || (month === compareMonth && day >= compareDay)) ? year : year - 1;
    });

    const uniqueYears = Array.from(new Set(years));
    return uniqueYears.sort((a, b) => a - b);
}
const getIndexesOfValueInArray = (array, value) => {
  let indexesOfValueInArray = []
  for(let index in array) {
     if (array[index] === value){
      indexesOfValueInArray.push(index);
     }
  }
  return indexesOfValueInArray;
}

export const calculateAveragePerWaterYear = (uniqueMonthAndDay, monthAndDayDates, values) => {
    let averageValue = [];
    for (let MonthAndDay of uniqueMonthAndDay) {
        let indexesOfValueInArray = getIndexesOfValueInArray(monthAndDayDates, MonthAndDay);
        let valuesTmpArray = [];
        indexesOfValueInArray.forEach( indexOfValue => {
          valuesTmpArray.push(values[indexOfValue]);
        })
        averageValue.push(average(valuesTmpArray));
    }
    return averageValue;
}

// In %Y-%m-%d format
export const getMonthAndDayFromStrDate = (date) =>   {
    const [, month, day] = date.split("-");
    return `${month}-${day}`;
}

export const setWaterYearToDates = (dates, startWaterYear) => {

    const referenceDateParts = startWaterYear.split('-').map(Number);
    const referenceMonth = referenceDateParts[0];
    const referenceDay = referenceDateParts[1];
  
    let adjustedDates = [];
    dates.forEach(date => {
        const dateParts = date.split('-').map(Number);
        const dateMonth = dateParts[0];
        const dateDay = dateParts[1];
  
        let adjustedYear;
        if (dateMonth < referenceMonth || (dateMonth === referenceMonth && dateDay < referenceDay)) {
            adjustedYear = 2004;
        } else {
            adjustedYear = 2003;
        }
        adjustedDates.push(`${adjustedYear}-${date}`);
    });
    return adjustedDates;
  
  }
  
export const sortAdjustedDates = (adjustedDates) => {
    const adjustedDatesArr = [...adjustedDates];
    return adjustedDatesArr.sort((a, b) => {
        return new Date(a) - new Date(b);
    });
  }
  
export const sortValuesByDates = (dates, sortedAdjustedDates, values) =>{
    return sortedAdjustedDates.map(( originalDate ) => {
        const index = dates.indexOf(originalDate);
        return values[index];
    });
  }

export const filterDatesAndValues = (startYearForAverageCalculation, endYearForAverageCalculation, targetMonthDay, datesArray, valuesArray) => {
  
    // Parse target month and day
    const [targetMonth, targetDay] = targetMonthDay.split('-').map(Number);

    // // Calculate start and end dates for comparison
    const startDateObj = new Date(`${startYearForAverageCalculation}-${targetMonth}-${targetDay}`);
    const endDateObj = new Date(`${endYearForAverageCalculation}-${targetMonth}-${targetDay}`);
    endDateObj.setMonth(endDateObj.getMonth() - 1); // Set to last day of previous month

    // Filter dates and values within the specified range
    const filteredDates = [];
    const filteredValues = [];
    datesArray.forEach((dateStr, index) => {
        const [year, month, day] = dateStr.split('-').map(Number);
        const currentDate = new Date(year, month - 1, day);

        // Check if the date is within the specified range
        if (currentDate >= startDateObj && currentDate < endDateObj) {
            filteredDates.push(dateStr);
            filteredValues.push(valuesArray[index]);
        }
    });

  return [filteredDates, filteredValues];
}
export const filterCurrentWaterYearValues = (todaysDate, datesArray, valuesArray, water_year_start_month_and_day, water_year_end_month_and_day) => {
    const filteredDates = [];
    const filteredValues = [];
    const [todaysYear, todaysMonth, ] = todaysDate.split('-').map(Number);
    const [WYSmonth, WYSday] = water_year_start_month_and_day.split('-').map(Number);
    const [WYEmonth, WYEday] = water_year_end_month_and_day.split('-').map(Number);
    let waterYearStartDate, waterYearEndDate
    if (todaysMonth >= WYSmonth) {
        waterYearStartDate = new Date(`${todaysYear}-${WYSmonth}-${WYSday}`);
        waterYearEndDate = new Date(`${todaysYear + 1}-${WYEmonth}-${WYEday}`);
    } else {
        waterYearStartDate = new Date(`${todaysYear - 1}-${WYSmonth}-${WYSday}`);
        waterYearEndDate = new Date(`${todaysYear}-${WYEmonth}-${WYEday}`);
    }
    datesArray.forEach((dateStr, index) => {
        const [year, month, day] = dateStr.split('-').map(Number);
        const currentDate = new Date(`${year}-${month}-${day}`);
        if (currentDate >= waterYearStartDate && currentDate < waterYearEndDate) {
            filteredDates.push(dateStr);
            filteredValues.push(valuesArray[index]);
        }
    });
    return [filteredDates, filteredValues];
}

const average = (arr) => arr.reduce((a, b) => a + b, 0) / arr.length;

export const getAllDatesInCurrentWaterYear = (todaysDate, water_year_start_month_and_day, water_year_end_month_and_day) => {
    // const [todaysYear, todaysMonth, todaysDay] = todaysDate.split('-').map(Number);
    let [todaysYear, todaysMonth, ] = todaysDate.split('-').map(Number);
    // todaysYear = '2024';
    const [WYSmonth, WYSday] = water_year_start_month_and_day.split('-').map(Number);
    const [WYEmonth, WYEday] = water_year_end_month_and_day.split('-').map(Number);
    let waterYearStartDate, waterYearEndDate
    if (todaysMonth >= WYSmonth) {
        waterYearStartDate = new Date(`${todaysYear}-${WYSmonth}-${WYSday}`);
        waterYearEndDate = new Date(`${todaysYear + 1}-${WYEmonth}-${WYEday}`);
    } else {
        waterYearStartDate = new Date(`${todaysYear - 1}-${WYSmonth}-${WYSday}`);
        waterYearEndDate = new Date(`${todaysYear}-${WYEmonth}-${WYEday}`);
    }
    const startDate = waterYearStartDate;
    const endDate = waterYearEndDate;
    const dates = [];
    
  
    let currentDateIterator = new Date(startDate);
    while (currentDateIterator <= endDate) {
      const year = currentDateIterator.getFullYear();
      const month = String(currentDateIterator.getMonth() + 1).padStart(2, '0');
      const day = String(currentDateIterator.getDate()).padStart(2, '0');
      dates.push(`${year}-${month}-${day}`);
    
    
      // Add one day
      currentDateIterator.setDate(currentDateIterator.getDate() + 1);
    }
    
  
    return dates
  }

export const getleapDay = (todaysDate, water_year_start_month_and_day) => {
    let [todaysYear, todaysMonth, ] = todaysDate.split('-').map(Number);
    const [WYSmonth, ] = water_year_start_month_and_day.split('-').map(Number);
    if (todaysMonth >= WYSmonth) {
        return `${todaysYear + 1}-02-28`
    } else {
        return `${todaysYear}-02-28`;
    }

}